// login popup redirection
class LoginRedirection extends HTMLElement {
    constructor() {
        super();
        this.loginRedirectionButton = this.querySelector('.login-redirection__button');
        if (this.loginRedirectionButton) {
            this.loginRedirectionButton.addEventListener('click', (event) => {
                this.handleRedirection(event);
            });
        }
    }

    handleRedirection(event) {
        const redirectionUrl = event.target.dataset.pageUrl;
        if (!redirectionUrl) {
            return;
        }

        sessionStorage.setItem('redirectionPath', redirectionUrl);
        window.location.href = '/account';
    }
}

customElements.define('login-redirection', LoginRedirection);

